import passports from './store/passports'

export default passports
